import { useEffect, useState } from 'react';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { useFlowCategories } from '@Hooks/useFlowCategories';
import { toastError } from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import FlowCategoryCard from '@Components/FlowCategoryCard';

const INITIAL_LIMIT = 4;

export default function FlowCategoryPreview() {
  const [showAll, setShowAll] = useState(false);

  const {
    data: categories,
    isError,
    error,
    isLoading,
  } = useFlowCategories({
    searchParams: {
      include: 'flows',
    },
  });

  useEffect(() => {
    if (isError && error) {
      toastError(
        error instanceof Error ? error.message : 'Failed to load Categories',
      );
    }
  }, [isError, error]);

  const allCategories = categories?.data ?? [];
  const hasMore = allCategories.length > INITIAL_LIMIT;
  const visible = showAll
    ? allCategories
    : allCategories.slice(0, INITIAL_LIMIT);

  if (isLoading || !allCategories.length) return null;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full justify-center">
        <span className="text-3xl">Flow Categories</span>
      </div>
      <div className="grid grid-cols-4 gap-6">
        {visible.map((category) => {
          return <FlowCategoryCard key={category.id} category={category} />;
        })}
      </div>

      {hasMore && (
        <div className="flex justify-center">
          <Button
            variant="secondary"
            onClick={() => setShowAll((prev) => !prev)}
          >
            {showAll ? 'Hide' : `Show all (${allCategories.length})`}
          </Button>
        </div>
      )}
    </div>
  );
}
